"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function ContactInformation() {
  const {
    ref: leftCardRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightCardRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="контактна-информация" className="relative py-20 bg-[hsl(210,15%,20%)] overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      <div className="container mx-auto px-6 md:px-12 lg:px-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {}
          <div ref={leftCardRef} className={`transition-all duration-[500ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <Card className="bg-[hsl(210,15%,25%)] border-none shadow-[0_8px_24px_rgba(0,0,0,0.4)] hover:shadow-[0_16px_32px_rgba(0,0,0,0.5)] hover:-translate-y-2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:brightness-[1.03] rounded-lg">
              <CardContent className="p-8 space-y-8">
                <h2 className="font-display text-[32px] leading-[1.25] font-bold text-white mb-6">
                  Свържете се с нас
                </h2>

                {}
                <div className="flex items-start gap-5 group">
                  <div className="relative">
                    <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
                    <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[hsl(15,85%,53%)] to-[hsl(15,85%,43%)] flex items-center justify-center shadow-[0_4px_12px_rgba(0,0,0,0.3)]">
                      <Phone className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-[18px] font-semibold text-white mb-1">
                      Телефон
                    </h3>
                    <p className="text-[hsl(0,0%,80%)] text-[16px]">+359 888 007 342</p>
                  </div>
                </div>

                {}
                <div className="flex items-start gap-5 group">
                  <div className="relative">
                    <div className="absolute inset-0 bg-secondary/20 blur-xl rounded-full" />
                    <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[hsl(95,50%,50%)] to-[hsl(95,50%,40%)] flex items-center justify-center shadow-[0_4px_12px_rgba(0,0,0,0.3)]">
                      <Mail className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-[18px] font-semibold text-white mb-1">
                      Имейл
                    </h3>
                    <p className="text-[hsl(0,0%,80%)] text-[16px]">mishmashinterpred.orders@gmail.com</p>
                  </div>
                </div>

                {}
                <div className="flex items-start gap-5 group">
                  <div className="relative">
                    <div className="absolute inset-0 bg-accent/20 blur-xl rounded-full" />
                    <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[hsl(210,80%,70%)] to-[hsl(210,80%,60%)] flex items-center justify-center shadow-[0_4px_12px_rgba(0,0,0,0.3)]">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-[18px] font-semibold text-white mb-1">
                      Адрес
                    </h3>
                    <p className="text-[hsl(0,0%,80%)] text-[16px]">бул. Цар Борис III 159&nbsp;</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={rightCardRef} className={`transition-all duration-[500ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <Card className="bg-[hsl(210,15%,25%)] border-none shadow-[0_8px_24px_rgba(0,0,0,0.4)] hover:shadow-[0_16px_32px_rgba(0,0,0,0.5)] hover:-translate-y-2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:brightness-[1.03] rounded-lg h-full">
              <CardContent className="p-8 flex flex-col justify-between h-full">
                <div className="space-y-8">
                  <h2 className="font-display text-[32px] leading-[1.25] font-bold text-white mb-6">
                    Работно време
                  </h2>

                  {}
                  <div className="flex items-start gap-5">
                    <div className="relative">
                      <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
                      <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[hsl(15,85%,53%)] to-[hsl(15,85%,43%)] flex items-center justify-center shadow-[0_4px_12px_rgba(0,0,0,0.3)]">
                        <Clock className="w-6 h-6 text-white" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-[18px] font-semibold text-white mb-1">Понеделник - Петък</h3>
                      <p className="text-[hsl(0,0%,80%)] text-[16px]">08:00 - 16:00</p>
                    </div>
                  </div>
                </div>

                {}
                <div className="mt-12 pt-8 border-t border-[hsl(0,0%,35%)]">
                  <h3 className="font-display text-[18px] font-semibold text-white mb-4">
                    Последвайте ни
                  </h3>
                  <div className="flex gap-4">
                    <Link to="https://www.facebook.com/share/1BW5mcC5Qv/" className="w-12 h-12 rounded-full bg-gradient-to-br from-[hsl(210,80%,70%)] to-[hsl(210,80%,60%)] flex items-center justify-center shadow-[0_4px_12px_rgba(0,0,0,0.3)] hover:scale-110 transition-transform duration-[var(--duration-fast)] ease-[var(--ease-smooth)]" aria-label="Facebook">
                      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                      </svg>
                    </Link>
                    
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}